import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { Button, FormCheck, Row } from 'react-bootstrap';
import DatePickerCustom from '../../../../../component/date-picker/DatePickerCustom';
import LabelRequired from '../../../../../component/LabelRequired';
import TextField from '../../../../../component/TextField';
import { IDanhSachDanhMuc } from '../../../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel';
import { CODE, KEY_DS_DANH_MUC_TIEP_DON } from '../../../../../utils/Constant';
import { getIndexedDBItem } from '../../../../../utils/IndexedDB';
import ProvisonalDiagnosis from '../../../../../phan-he-kham-benh/components/ProvisonalDiagnosis';
import ICD10 from '../../../../../phan-he-kham-benh/components/ICD10';
import AutocompleteV2 from '../../../../../component/AutocompleteObjectV2';
import { getDsPhieuDieuTri } from '../../../../services/BenhAnServices';
import { usePhanHeDieuTriNoiTruContext } from '../../../../PhanHeDieuTriContext';
import { formatDateDTO, formatDateTime } from '../../../../../utils/FormatUtils';
import { useKeVatTuContext } from '../../context';
import NgayKeTuDong from '../../../../../phan-he-kham-benh/modals/modal-ke-thuoc/components/NgayKeTuDong';
import PhieuDieuTriDialog from '../../../benh-an/components/content/components/thong-tin-benh-an/components/phieu-dieu-tri/components/PhieuDieuTriDialog';

const ThongTinBenh = () => {
	const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();
	const { phieuDieuTri, isEdit } = useKeVatTuContext();
	const { values, setFieldValue, errors, setValues, touched } = useFormikContext<any>();
	const [listICD10, setListICD10] = useState<any>([]);
	const [listComorbidity, setListComorbidity] = useState<any[]>([]);
	const [shouldOpenModalSelectICD10, setShouldOpenModalSelectICD10] = useState<boolean>(false);
	const [shouldOpenModalICD10, setShouldOpenModalICD10] = useState<boolean>(false);
	const [selectionModeICD10, setSelectionModeICD10] = useState<'checkbox' | 'radio'>('radio');
	const [openPhieuDieuTriDialog, setOpenPhieuDieuTriDialog] = useState<boolean>(false);
	const [dsPhieuDieuTri, setDsPhieuDieuTri] = useState<any[]>([]);

	const handleOpenSelectICD10 = () => {
		setShouldOpenModalSelectICD10(true);
	};

	useEffect(() => {
		getDanhMucICD10();
	}, []);

	const getDanhMucICD10 = async () => {
		const danhMuc: IDanhSachDanhMuc = await getIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON);
		setListICD10(danhMuc.listICD10);
	};

	const handleChangeICD10 = (data: any) => {
		setValues({
			...values,
			...data,
		});
	};


	const handleGetDsPhieuDieuTri = async () => {
		try {
			const { data } = await getDsPhieuDieuTri({
				patientId: benhNhanDieuTri?.patientId,
				visitId: benhNhanDieuTri?.visitId,
				medicalRecordCode: benhNhanDieuTri?.medicalRecordCode,
			});
			if (data?.code === CODE.SUCCESS) {
				setDsPhieuDieuTri(data?.data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		if (benhNhanDieuTri?.patientId && benhNhanDieuTri?.visitId && benhNhanDieuTri?.medicalRecordCode) handleGetDsPhieuDieuTri();
	}, [benhNhanDieuTri?.patientId, benhNhanDieuTri?.visitId, benhNhanDieuTri?.medicalRecordCode]);

	return (
		<>
			<div className="d-flex justify-content-between w-80">
				<div className="spaces mb-4 d-flex align-items-center">
					<DatePickerCustom
						label="Ngày y lệnh"
						name="ngayYLenh"
						labelClassName="spaces ms-0 min-w-120"
						value={values.ngayYLenh}
						setDateValue={date => {
							setFieldValue('ngayYLenh', date);
						}}
						mode="date-time"
						errors={errors?.ngayYLenh}
						touched={touched?.ngayYLenh}
						disabled
					/>
					<FormCheck
						className="ms-3 mt-1 spaces min-w-100"
						label="Thu tiền"
						type="checkbox"
						name="thuTien"
						checked={values.thuTien}
						onChange={e => setFieldValue('thuTien', e.target.checked)}
						isInvalid={!!errors.thuTien}
					/>
					<div className='d-flex align-items-center'>
						<LabelRequired
							label="Phiếu điều trị:"
							className="spaces min-w-110"
							isRequired
						/>
						<div className="spaces W-200">
							<AutocompleteV2
								options={dsPhieuDieuTri || []}
								getOptionLabel={option => formatDateTime(option?.prescriptionDate) as string}
								value={values?.treatmentSheet || phieuDieuTri}
								name="treatmentSheet"
								onChange={selectedOption => setValues({
									...values,
									treatmentSheet: selectedOption,
									ngayYLenh: formatDateDTO(selectedOption?.prescriptionDate)
								})}
								className="autocomplete-custom-tiep-nhan radius spaces h-29"
								errors={errors?.treatmentSheet}
								touched={touched?.treatmentSheet}
							/>
						</div>
						<Button
							variant='link'
							className='link-info text-decoration-underline spaces py-0 pl-10 min-w-150'
							onClick={() => setOpenPhieuDieuTriDialog(true)}
						>
							Thêm phiếu điều trị
						</Button>
					</div>
				</div>
				<Button
					className="bg-white"
					onClick={handleOpenSelectICD10}
				>
					<u className="fw-bold text-pri fs-13px">Chọn bệnh</u>
				</Button>
			</div>

			<div className="d-flex flex-wrap w-80">
				<LabelRequired label="Chẩn đoán" className="spaces min-w-120" />
				<Row className='flex-grow-1 position-relative'>
					<ProvisonalDiagnosis
						encounterDiagnosisValues={values}
						encounterDiagnosisErrors={errors}
						encounterDiagnosisTouched={touched}
						listComorbidity={listComorbidity}
						setListComorbidity={setListComorbidity}
						onChange={(data: any) =>
							setValues({
								...values,
								...data,
							})
						}
						handleChangeEncounterDiagnosis={setFieldValue}
					/>
				</Row>
			</div>

			<div className="spaces mt-4 w-100 d-flex">
				<div className={`d-flex spaces width-${isEdit ? "80" : "57"}`}>
					<div className="d-flex">
						<LabelRequired
							label="Bệnh kèm theo"
							className="d-inline-block spaces min-w-120-px text-truncate"
						/>
					</div>
					<div className="spaces position-relative w-100">
						<TextField
							className="w-100 d-flex flex-column align-items-start"
							inputClassName="flex-auto spaces h-25 radius-3px pre-line"
							name="comorbidity"
							labelClassName="ms-0 min-w-145px"
							// readOnlyText
						/>
					</div>
				</div>
				{!isEdit && (
					<div className="flex-grow-1 ps-5">
						<NgayKeTuDong name="autoPrescriptions" treatmentId={benhNhanDieuTri?.treatmentId} />
					</div>
				)}
			</div>

			<ICD10
				shouldOpenModalICD10={shouldOpenModalICD10}
				setShouldOpenModalICD10={setShouldOpenModalICD10}
				shouldOpenModalSelectICD10={shouldOpenModalSelectICD10}
				setShouldOpenModalSelectICD10={setShouldOpenModalSelectICD10}
				listICD10={listICD10}
				listComorbidity={listComorbidity}
				setListComorbidity={setListComorbidity}
				selectionModeICD10={selectionModeICD10}
				data={values}
				onChange={handleChangeICD10}
			/>
			{openPhieuDieuTriDialog && (
				<PhieuDieuTriDialog
					open={openPhieuDieuTriDialog}
					onClose={() => setOpenPhieuDieuTriDialog(false)}
					callbackFunc={(data: any) => setValues({
						...values,
						treatmentSheet: data,
						ngayYLenh: formatDateDTO(data?.prescriptionDate)
					})}
				/>
			)}
		</>
	);
};

export default ThongTinBenh;
